import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import styles from './Footer.scss'
import {rideReportSelectors} from 'data/resources/rideReports'
import {Icon} from 'common/Icon'
import {getReportCover} from 'lib/getReportCover'
import {clampStringWords} from 'lib/utils'
import moment from 'moment'

const RelatedCard = ({report, journalArticle}) => (
  <div className={styles.RelatedCard}>
    <Link to={`/${journalArticle ? 'journal' : 'ride_reports'}/${report.slug}`} className={styles.gutterHack} style={{backgroundImage: `url(${getReportCover(report)})`}}>
      <div className={styles.onTop}>
        <h3>{report.title}</h3>
        <p>{report.subtitle && clampStringWords(report.subtitle, 120)}</p>
      </div>
    </Link>
  </div>
)

// just used for related news right now
const _FlatRelated = ({report, v3Report}) => {
  const v3 = v3Report(report.slug)
  let link
  if (v3 && v3.authorUrl) {
    link = <Fragment>
      <Icon i='md-open' style={{paddingRight: '10px'}} />
      <Link href={v3.authorUrl} className={styles.flatTitle}>{report.title}</Link>
    </Fragment>
  } else {
    link = <Link to={`/news/${report.slug.split('-').slice(1).join('-')}`} className={styles.flatTitle}>{report.title}</Link>
  }

  return <div className={styles.flat}>
    {link}
    <div className={styles.flatPublished}>{moment(report.publishedAt).format('MMMM DD, YYYY')}</div>
  </div>
}

export const Footer = ({report, relatedReports, journalArticle, newsArticle}) => {
  let link
  if (journalArticle) {
    link = <Link to={'/journal'} className={styles.userLink}>the Journal</Link>
  } else if (newsArticle) {
    link = 'News'
  } else {
    link = <Link to={`/ride_reports/user/${report.user.id}`} className={styles.userLink}>{report.user.name}</Link>
  }

  return <div className={styles.Footer}>
    <hr />
    <div className={styles.related}>
      {relatedReports && relatedReports.size > 0 && <h2 className={styles.heading}>
        {newsArticle ? 'More' : 'More stories from'} {link}:
      </h2>}
      {relatedReports && relatedReports.size > 0 && (
        <div className={styles.relatedCardContainer}>
          {relatedReports.map(r => newsArticle
            ? <FlatRelated key={r.id} report={r} />
            : <RelatedCard key={r.id} report={r} journalArticle={journalArticle} />)}
        </div>
      )}
    </div>
    {!(journalArticle || newsArticle) && <p className={styles.plug}>This ride report was made with Ride with GPS. Share your own stories with a free account at <a href='/'>ridewithgps.com</a>.</p>}
  </div>
}

const mapStateToProps = (state) => ({
  v3Report: slug => rideReportSelectors.bySlug(state, slug)
})

const FlatRelated = connect(
  mapStateToProps,
  null
)(_FlatRelated)
